import { UrlMatcher, UrlSegment } from '@angular/router';

/**
 * @description 
 *  - Custom URL matcher to identify and redirect old 'quality' routes to new 'water-quality-iq' routes.
 *  - This matcher checks if the first segment of the URL is 'quality'.
 *  - If a match is found, it triggers the QualityRedirectGuard to handle the redirection.
 * 
 * @param url 
 *  - The array of URL segments to be matched. 
 * @returns 
 *  - An object with the consumed URL segments if a match is found, otherwise undefined.
 */

export const feedflexRedirectMatcher: UrlMatcher = (url: UrlSegment[]) => {
  if (url?.length && url[0]?.path === 'feed-flex') {
    return { consumed: url };
  }
};